import React, { Component } from 'react'
import { TabelaScorpion } from 'scorpion-core'
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Edit from '@material-ui/icons/Edit';
import { Button, Menu, MenuItem } from '@material-ui/core';
import PainelEmiteRelatorio from '../../routes/sistema/OkReportDeveloper/components/PainelEmiteRelatorio';
import Tabela from './componente/Tabela';

import View from 'react-flexbox'

export default class TabelaConsulta extends Component {
    constructor(props) {
        super(props)
        this.state = { menuAberto: null, anchorEl: null }
        this.abreMenu = this.abreMenu.bind(this)
        this.fechaMenu = this.fechaMenu.bind(this)
    }

    abreMenu(item, event) {
        this.setState({ anchorEl: event.currentTarget, menuAberto: item });
    };
    fechaMenu = () => {
        this.setState({ anchorEl: null, menuAberto: null });
    };


    render() {
        const { colunas, lista, tipoModeloRelatoriosUnico, editar, mensagemVazio, loading, botoesAntes } = this.props;
        const { anchorEl, menuAberto } = this.state;
        let colunasComBotoes = []
        if (botoesAntes) {
            colunasComBotoes.push({
                id: '...', numeric: true, disablePadding: false, label: '', getValue: (item) => {
                    return <div style={{ display: "flex", alignItems: 'center', justifyContent: 'flex-end' }}>
                        {editar && <Button
                            onClick={() => editar(item)}
                        >
                            <Edit />
                        </Button>}
                        <Button
                            aria-owns={anchorEl ? 'simple-menu' : null}
                            aria-haspopup="true"
                            onClick={(event) => this.abreMenu(item, event)}
                        >
                            <MoreHoriz />
                        </Button>
                    </div>


                }
            })
        }
        colunasComBotoes = colunasComBotoes.concat(colunas);
        if (!botoesAntes) {
            colunasComBotoes.push({
                id: '...', numeric: true, disablePadding: false, label: '', getValue: (item) => {
                    return <div style={{ display: "flex", alignItems: 'center', justifyContent: 'flex-end' }}>
                        {editar && <Button
                            onClick={() => editar(item)}
                        >
                            <Edit />
                        </Button>}
                        <Button
                            aria-owns={anchorEl ? 'simple-menu' : null}
                            aria-haspopup="true"
                            onClick={(event) => this.abreMenu(item, event)}
                        >
                            <MoreHoriz />
                        </Button>
                    </div>


                }
            })
        }
        return (<View column style={{ justifyContent: 'flex-start', flex: 1, overflow: 'auto', height: 1 }}>
            <Tabela colunas={colunasComBotoes} data={lista} mensagemVazio={mensagemVazio ? mensagemVazio : "Sem Itens"} loading={loading} paginacao={"10"} />
            <Menu
                anchorEl={anchorEl}
                open={anchorEl ? true : false}
                onClose={this.fechaMenu}
            >
                <MenuItem onClick={() => {
                    this.dialogRelatorio.show();
                    this.setState({ anchorEl: null })
                }
                }>Relatórios</MenuItem>

            </Menu>
            <PainelEmiteRelatorio
                ref={connectedComponent => {
                    if (connectedComponent) {
                        this.dialogRelatorio = connectedComponent.refs.wrappedInstance
                    }
                }}
                tipoModelo={tipoModeloRelatoriosUnico}
                dados={menuAberto}
            />


        </View >
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ConsultaCrud/TabelaConsulta.js